import Vue from 'vue';
import moment from 'moment';
import warehouseTransactionTransformer from './../../transformers/warehouseTransactionV2';
import warehouseReportTransformer from './../../transformers/warehouseReport';

const success = ({ data }, resolve, groupByProduct) => {
  let report = null;
  if (groupByProduct) {
    report = warehouseReportTransformer.fetchCollection(data.data);
  } else {
    report = warehouseTransactionTransformer.fetchCollection(data.data);
  }

  resolve(report);
};

const failed = (error, reject) => reject(error);


export default (options, limit = null) => (
  new Promise((resolve, reject) => {
    let url = '/reports/warehouses_transactions';
    const query = [];

    if (limit) {
      query.push(`limit=${limit}`);
    }

    if (options.warehouseId) {
      query.push(`warehouse_id=${options.warehouseId}`);
    }

    if (options.transactionTypeId) {
      query.push(`transaction_type_id=${options.transactionTypeId}`);
    }

    if (options.dateOption === 'as_of_date') {
      if (options.asOfDate) {
        const asOfDate = moment(options.asOfDate).format('YYYY-MM-DD');
        query.push(`asOfDate=${asOfDate}`);
      }

      if (options.hideOutOfStock) {
        query.push(`hide_out_of_stock=${options.hideOutOfStock}`);
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (options.transactionDateRange.length) {
        const start = moment(options.transactionDateRange[0]).format('YYYY-MM-DD');
        const end = moment(options.transactionDateRange[1]).format('YYYY-MM-DD');
        query.push(`start=${start}`);
        query.push(`end=${end}`);
      }
    }

    if (options.groupByProduct) {
      query.push(`group_by_product=${options.groupByProduct}`);
    }

    if (query.length > 0) {
      url += '?';
      query.map((q) => {
        url += `${q}&`;
        return q;
      });
      url = url.substring(0, url.length - 1);
    }

    Vue.$http.get(url)
    .then((response) => {
      success(response, resolve, options.groupByProduct);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/report/warehouseTransactions.js